import { Button } from '@material-ui/core';
import { useEffect } from 'react';
import en from '../../../../lang/en-us';
import SuccessScreen from '../SuccessScreen';
const { dashboard } = en;

export default function BankMandateSuccess(props: any) {
    const { reqId } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
    }, []);

    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.UpdateNominee.Success.back}
                backLink="nct"
                info1={dashboard.UpdateNominee.Success.subHeadingInfo1}
                infospan1="Reinvest to Payment"
                info2={dashboard.UpdateNominee.Success.subHeadingInfo2}
                infospan2={`${reqId}`}
                info3={dashboard.UpdateNominee.Success.subHeadingInfo3}
                handleClick={() => props.history.push('/portal/track')}
                backNavigation={() => props.history.goBack()}
            />
        </div>
    );
}
